export default __webpack_public_path__ + "static/media/dgx.868d5228.svg";